var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.114 1.57215C16.4266 -0.535898 19.4953 -0.535896 20.8079 1.57215L21.9062 3.33594C22.6649 4.55434 24.1147 5.15491 25.5127 4.82982L27.5365 4.35923C29.9553 3.79678 32.1252 5.96665 31.5627 8.38543L31.0921 10.4092C30.767 11.8072 31.3676 13.2571 32.586 14.0158L34.3498 15.114C36.4578 16.4266 36.4578 19.4953 34.3498 20.8079L32.586 21.9062C31.3676 22.6649 30.767 24.1147 31.0921 25.5127L31.5627 27.5365C32.1252 29.9553 29.9553 32.1252 27.5365 31.5627L25.5127 31.0921C24.1147 30.767 22.6649 31.3676 21.9062 32.586L20.8079 34.3498C19.4953 36.4578 16.4266 36.4578 15.114 34.3498L14.0158 32.586C13.2571 31.3676 11.8072 30.767 10.4092 31.0921L8.38542 31.5627C5.96665 32.1252 3.79678 29.9553 4.35923 27.5365L4.82983 25.5127C5.15491 24.1147 4.55434 22.6649 3.33594 21.9062L1.57215 20.8079C-0.535898 19.4953 -0.535896 16.4266 1.57215 15.114L3.33594 14.0158C4.55434 13.2571 5.15491 11.8072 4.82982 10.4092L4.35923 8.38542C3.79678 5.96665 5.96665 3.79678 8.38543 4.35923L10.4092 4.82983C11.8072 5.15491 13.2571 4.55434 14.0158 3.33594L15.114 1.57215Z",
    fill: "#59B5CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/blue-star.1f79eb15c11e6ec045e3b99e4bcaf31f.svg";
export { ForwardRef as ReactComponent };